import React from "react";

export const defaultRoles = [
  {
    category: "Board of directors (BOD)",
    male_number: "",
    male_median: "",
    female_number: "",
    female_median: "",
  },
  {
    category: "Key Managerial persons (KMP)",
    male_number: "",
    male_median: "",
    female_number: "",
    female_median: "",
  },
  {
    category: "Employees",
    male_number: "",
    male_median: "",
    female_number: "",
    female_median: "",
  },
  {
    category: "Workers",
    male_number: "",
    male_median: "",
    female_number: "",
    female_median: "",
  },
];

const RemunerationTable = ({ remunerationdata, setRemunerationData }) => {
  const rows =
    Array.isArray(remunerationdata) && remunerationdata.length > 0
      ? remunerationdata
      : defaultRoles;

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRemunerationData(updated);
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE" }}>
            <th rowSpan="2" style={headerStyle}>
              Category
            </th>
            <th colSpan="2" style={headerStyle}>
              Male
            </th>
            <th colSpan="2" style={headerStyle}>
              Female
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE" }}>
            <th style={headerStyle}>Number</th>
            <th style={headerStyle}>
              Median remuneration/ wages/ salary of respective category
            </th>
            <th style={headerStyle}>Number</th>
            <th style={headerStyle}>
              Median remuneration/ wages/ salary of respective category
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.category}>
              <td style={rowHeaderStyle}>{row.category}</td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.male_number}
                  onChange={(e) =>
                    handleChange(index, "male_number", e.target.value)
                  }
                  placeholder="Enter"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.male_median}
                  onChange={(e) =>
                    handleChange(index, "male_median", e.target.value)
                  }
                  placeholder="Enter"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.female_number}
                  onChange={(e) =>
                    handleChange(index, "female_number", e.target.value)
                  }
                  placeholder="Enter"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.female_median}
                  onChange={(e) =>
                    handleChange(index, "female_median", e.target.value)
                  }
                  placeholder="Enter"
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  fontWeight: "bold",
  verticalAlign: "middle",
  backgroundColor: "#D3C9CE",
};

const rowHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  backgroundColor: "#D3C9CE",
  textAlign: "left",
  fontWeight: "bold",
  whiteSpace: "nowrap",
};

const cellStyle = {
  padding: "8px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputStyle = {
  width: "100%",
  padding: "6px",
  fontSize: "14px",
  borderRadius: "4px",
  border: "1px solid gray",
  textAlign: "center",
};

export default RemunerationTable;
